import React from 'react'

import { Tooltip } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, object, string } from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'

function SubscriptionActions({
  isDownloadable,
  isModel,
  isCollection,
  modelDownloadData,
  collectionDownloadData,
  isRedownload = false,
  itemId,
  onDownloadClick: handleDownloadClick = null,
}) {
  if (!isModel && !isCollection) {
    return <small>Not available</small>
  }

  const currentDataSet = isModel ? modelDownloadData : collectionDownloadData
  const isDisabled = !isDownloadable

  const handleClick = () => {
    if (!isDisabled && handleDownloadClick) {
      handleDownloadClick(itemId, isRedownload)
    }
  }

  const redownloadTitle = 'Re-download does not count toward your limit'
  const defaultTitle = 'Download files'

  function getTitle() {
    if (isRedownload) return redownloadTitle
    return defaultTitle
  }

  const button = (
    <button
      data-href={isDisabled ? undefined : currentDataSet.href}
      data-toggle={isDisabled ? undefined : currentDataSet.toggle}
      data-target={isDisabled ? undefined : currentDataSet.target}
      title={isDisabled ? undefined : getTitle()}
      className={
        `cgt-button cgt-button--primary js-download cgt-mr-10 cgt-mb-10${isDisabled ? ' subscription-actions__download--disabled' : ''}`
      }
      onClick={handleClick}
      disabled={isDisabled}
      aria-disabled={isDisabled}
    >
      <Icon type={['fas', 'cloud-download']} />
      {isRedownload ? 'Re-download' : 'Download'}
    </button>
  )

  if (isDisabled) {
    return (
      <div className="actions-row">
        <Tooltip
          id={`disabled-download-${itemId}`}
          randomizeID
          content="Your subscription is no longer active"
          place="top"
        >
          {button}
        </Tooltip>
      </div>
    )
  }

  return (
    <div className="actions-row">
      {button}
    </div>
  )
}

SubscriptionActions.propTypes = {
  isDownloadable: bool.isRequired,
  isModel: bool.isRequired,
  isCollection: bool.isRequired,
  modelDownloadData: object.isRequired,
  collectionDownloadData: object.isRequired,
  isRedownload: bool,
  itemId: string.isRequired,
  onDownloadClick: func,
}

export default SubscriptionActions
